import { useState } from 'react';

import { featureFlags } from 'src/config/featureFlags';
import { ApprovalsMain } from './approvals/LogisticApprovals';
import { MainDetailsDeviations } from './deviations/Deviations';
import { useInvoiceContext } from '../InvoiceContextProvider';
import { MainDetailsTabs } from './Tabs';
import { MainDetailsSummary } from './Summary';
import { MainDetailsDisputeResult } from './DisputeResult';
import { ProcessingStagesMain } from './processingStages/ProcessingStagesMain';
import { MainDetailsTabsIndex } from './types';

export const MainDetails = () => {
  const { invoiceSummary } = useInvoiceContext();
  const [tabIndex, setTabIndex] = useState<MainDetailsTabsIndex>(MainDetailsTabsIndex.DEVIATIONS);

  const onChangeTab = (newValue: MainDetailsTabsIndex) => {
    setTabIndex(newValue);
  };

  return (
    <div className='flex flex-col h-full'>
      <MainDetailsSummary invoiceSummary={invoiceSummary} />
      <MainDetailsTabs tabIndex={tabIndex} invoiceSummary={invoiceSummary} onChange={onChangeTab} />

      {tabIndex === MainDetailsTabsIndex.APPROVALS && (
        <>{featureFlags?.SHOW_INVOICE_APPROVALS ? <ProcessingStagesMain /> : <ApprovalsMain invoiceSummary={invoiceSummary} />}</>
      )}

      {tabIndex === MainDetailsTabsIndex.DEVIATIONS && <MainDetailsDeviations invoiceSummary={invoiceSummary} />}

      {tabIndex === MainDetailsTabsIndex.DISPUTE_RESULT && <MainDetailsDisputeResult invoiceSummary={invoiceSummary} />}
    </div>
  );
};
